var map = {
	"./C-white.svg": 48864,
	"./M-white.svg": 13438,
	"./P-white.svg": 80639,
	"./R-white.svg": 78165,
	"./S-white.svg": 13832,
	"./T-white.svg": 89836,
	"./U-white.svg": 68851,
	"./V-white.svg": 58134
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79444;